<template>
    <div class="gz-expand">
        <span class="icon-ellipsis-v-solid"></span>
    </div>
</template>

<script>
export default {
    name: 'BaseExpandControl'
}
</script>